// No `theme` in here on purpose — RequestQuoteForm calls makeStyles without one.

export const ACCENT = "#C9A24B"

const BUTTON_BASE = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textWrap: "balance",
  textDecoration: "none",
  cursor: "pointer",
  boxSizing: "border-box",
  width: "100%",
  minHeight: 54,
  padding: "15px 24px",
  borderRadius: 999,
  fontFamily: "inherit", // <button> and <input> do not inherit the page font
  fontSize: 16,
  fontWeight: 500,
  lineHeight: 1.3,
  letterSpacing: "0.04em",
  WebkitAppearance: "none",
  appearance: "none",
  "&:focus": { outline: "none" },
  "&:focus-visible": { outline: `2px solid ${ACCENT}`, outlineOffset: 3 },
  ["@media (max-width:600px)"]: { padding: "15px 16px" },
}

export const CTA_BUTTON_PRIMARY = {
  ...BUTTON_BASE,
  fontWeight: 600,
  color: "#1a1a1a",
  backgroundColor: ACCENT,
  border: `1px solid ${ACCENT}`,
  transition: "opacity 0.2s ease",
  "&:hover": { opacity: 0.85 },
}

export const CTA_BUTTON_SECONDARY = {
  ...BUTTON_BASE,
  color: "white",
  backgroundColor: "transparent",
  border: "1px solid #5a5a5a",
  transition: "border-color 0.2s ease",
  "&:hover": { borderColor: "white" },
}

export const CTA_NOTE = {
  marginTop: 12,
  fontSize: "0.85rem",
  color: "#9d989a",
  letterSpacing: "0.02em",
  lineHeight: 1.5,
  textAlign: "left",
}
